import { useSelector } from 'react-redux';
import { MwcDescription } from '@common/Filters/components/MwcDescription';
import {
    getCount,
    getSelected,
    injectMadeWithCareDescription
} from '@common/Filters/helpers/filterItemHelpers';
import { FiltersListItemMobile as FiltersListItem } from './FiltersListItemMobile';

export function FiltersListM({
    filterType
}) {
    const { dropdownFilters, availableFilters, activeFilters } = useSelector(state => state.filters);

    const filterItems = () => {
        let items = dropdownFilters[filterType];

        // special case for size filter
        if (typeof items.options !== 'undefined') {
            items = items.options;
        }

        items = getCount(items, availableFilters[filterType]);
        items = getSelected(items, activeFilters);

        items = injectMadeWithCareDescription(items, <MwcDescription />);

        return items;
    };

    return (
        <div className="filters__list">
            {filterItems()
                .filter(filterItem => filterItem.count > 0)
                .map(filterItem => (
                    <FiltersListItem
                        key={`${filterItem.name}-${filterItem.value}`}
                        item={filterItem}
                    />
                ))}
        </div>
    );
}
